<template>
    <v-content class="follow-map" v-if="result">
      <div id="map">
          <GmapMap :center="center" ref="mapRef" :zoom="zoom" :options="mapStyle" style="width: 100%; height: 100%;">
              <GmapMarker :position="result.location" :title="result.name" :clickable="true" :draggable="false" :key="result.id" @click="MakerClick(result.location)"></GmapMarker>
          </GmapMap>
      </div>

      <div id="navi" class="" @click.stop="toMap()">
        <svg class="svg_maincolor_circle_fill" xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51"><circle cx="25.5" cy="25.5" r="25.5" fill="#ff00b1" opacity="0.699"/><path d="M27.9,8.8a2.7,2.7,0,1,0-2.7-2.7h0A2.689,2.689,0,0,0,27.9,8.8Zm5.2,8.3-1.3-.7-.5-1.6a6,6,0,0,0-5.7-4.2c-2,0-3.1.6-5.2,1.4a5.455,5.455,0,0,0-2.8,2.6l-.4.7a1.824,1.824,0,0,0,.8,2.4,1.681,1.681,0,0,0,2.3-.8h0l.4-.8a1.962,1.962,0,0,1,.9-.9l1.5-.6L22.4,18a3.586,3.586,0,0,0,.8,3.3l3.3,3.6a3.147,3.147,0,0,1,.8,1.5l1,4.1a1.746,1.746,0,0,0,3.4-.8v-.1l-1.2-4.9a2.751,2.751,0,0,0-.8-1.5l-2.5-2.7,1-3.8.3.9a3.694,3.694,0,0,0,1.8,2.1l1.3.7a1.681,1.681,0,0,0,2.3-.8h0a1.88,1.88,0,0,0-.8-2.5ZM20.4,24.9a3.166,3.166,0,0,1-.8,1.2l-2.8,2.8a1.754,1.754,0,0,0,.1,2.5,1.825,1.825,0,0,0,2.4,0l3.3-3.3a3.6,3.6,0,0,0,.8-1.2l.8-1.9c-3.1-3.3-2.1-2.3-2.6-3l-1.2,2.9Z" fill="#fff"/><path d="M5.7,31.8c0,.1,0,.1-.1.1a2.769,2.769,0,0,0-.9.1c-.7.3-.7,1.4,0,2.9a11.927,11.927,0,0,0,1.5,2.6c.1.1.1.1,0,.2a2.186,2.186,0,0,1-.5.3c-.1,0-.1,0-.2-.1A11.74,11.74,0,0,1,4,35.1c-.8-1.8-.8-3.2.4-3.7a1.9,1.9,0,0,1,1.3-.1Zm4.5.6c.3.7.7,1.4,1,2v.2c-.1.1-.2.1-.4.2-.1,0-.1,0-.2-.1a8.625,8.625,0,0,0-2.2-2c-.1-.1-.2-.1-.1-.3v-.5A12.492,12.492,0,0,1,10,33.1a4.671,4.671,0,0,1-.5-1,7.96,7.96,0,0,1-.7-2c0-.1,0-.1.1-.1.1.1.3,0,.5,0A9.611,9.611,0,0,0,10.2,32.4Z" fill="#fff"/><path d="M10.8,40.1c0,.1,0,.1-.1.1a1.531,1.531,0,0,0-.7.5c-.5.7,0,1.6,1.3,2.6a11.173,11.173,0,0,0,2.5,1.6.1.1,0,0,1,.1.1c0,.1-.2.3-.3.5,0,.1-.1.1-.2,0a27.284,27.284,0,0,1-2.6-1.7c-1.6-1.2-2.2-2.5-1.3-3.5a1.9,1.9,0,0,1,1.1-.7A1.689,1.689,0,0,0,10.8,40.1Zm4.3-1.6A10.72,10.72,0,0,0,17,39.8V40c-.1.1-.1.2-.3.4-.1.1-.1.1-.2,0a6.438,6.438,0,0,0-2.8-.7.215.215,0,0,1-.2-.2.52.52,0,0,0-.2-.4c.8.1,1.5.2,2,.3a7.051,7.051,0,0,1-.9-.7,10.633,10.633,0,0,1-1.5-1.5V37c.1-.1.2-.3.3-.4A6.85,6.85,0,0,0,15.1,38.5Z" fill="#fff"/><path d="M21.3,41.5c.1-.3.2-.6.3-1a2.994,2.994,0,0,1,.8.4.187.187,0,0,1,0,.3.769.769,0,0,0-.2.3,9.143,9.143,0,0,1-.7,1.4c.3,0,.8.1,1,.1.9.1,1.3.7,1.1,1.9a7.447,7.447,0,0,1-1.1,3.2,1.2,1.2,0,0,1-1.3.6,2.321,2.321,0,0,1-1-.4c-.1,0-.1-.1-.1-.2v-.6a3.446,3.446,0,0,0,1.1.5.8.8,0,0,0,.8-.4,6.5,6.5,0,0,0,.9-2.8c.1-.8,0-1.1-.5-1.2a4.1,4.1,0,0,0-1.1-.1A24.874,24.874,0,0,1,18.4,48c-.1.1-.1.1-.2,0s-.3-.2-.4-.3,0-.1,0-.2a25.539,25.539,0,0,0,2.7-4H19.1a.749.749,0,0,0-.5.1c-.1.1-.2,0-.3-.1a1.483,1.483,0,0,1-.1-.7,4.485,4.485,0,0,0,1.1.1h1.5C20.9,42.5,21.1,42.1,21.3,41.5ZM25,43c.1,0,.1,0,.1.1a5.135,5.135,0,0,1,1.2,2.7c0,.1,0,.1-.1.2a.764.764,0,0,1-.5.2c-.1,0-.2,0-.2-.1a5.8,5.8,0,0,0-1.2-2.9A6.374,6.374,0,0,0,25,43Z" fill="#fff"/><path d="M29.3,42.9c.1,0,.2.1.1.2v.5a15.536,15.536,0,0,0,.5,2.3A4.734,4.734,0,0,1,32.7,43a2,2,0,0,1,2.8,1.1,2.428,2.428,0,0,1-.8,2.6,8.554,8.554,0,0,1-2.2,1.5.188.188,0,0,1-.3,0c-.2-.1-.4-.3-.6-.3a8.743,8.743,0,0,0,2.5-1.5,1.794,1.794,0,0,0,.6-2c-.2-.7-.9-1.1-1.9-.7a4.884,4.884,0,0,0-2.4,2.5,2.544,2.544,0,0,0-.2.7.1.1,0,0,1-.1.1h-.5c-.1,0-.1,0-.1-.1a21.37,21.37,0,0,1-.8-3.2c-.1-.3-.1-.6-.2-.8Zm-.4-2.5c0-.1,0-.1.1-.1a6.308,6.308,0,0,1,2.2.5c.1,0,.1,0,.1.1a.764.764,0,0,1-.2.5c0,.1-.1.1-.2.1a7.945,7.945,0,0,0-2.2-.6C28.8,40.7,28.8,40.5,28.9,40.4Z" fill="#fff"/><path d="M40.1,36.1c.4-.4.8-.9,1.2-1.3.1-.1.1-.1.2,0l.3.3c.1.1.1.1,0,.2-.4.4-.8.9-1.2,1.3l-1,1.1a5.324,5.324,0,0,1,1.7,2.5,6.09,6.09,0,0,1,0,3,.215.215,0,0,1-.2.2,1.421,1.421,0,0,0-.6.2,5.161,5.161,0,0,0,.1-3A5.668,5.668,0,0,0,39,38.3l-1.5,1.6c-.4.4-.7.8-1,1.1-.1.1-.1.1-.2,0s-.3-.2-.5-.4A13.577,13.577,0,0,0,37,39.4l1.5-1.6c-.4-.4-.7-.6-1.1-1a5.5,5.5,0,0,0-.9-.7,3.735,3.735,0,0,1,.7-.6c.1-.1.2,0,.2.1a1.756,1.756,0,0,0,.4.5c.4.4.8.7,1.2,1.1Z" fill="#fff"/><path d="M43.3,31.8a15.544,15.544,0,0,0-.4-3.2,2.3,2.3,0,0,0-.4-1.1,3.039,3.039,0,0,1,.7-.5c.1-.1.3,0,.2.1a2.4,2.4,0,0,0,.2,1c.2,1.1.3,2.6.4,3.8l1.7.4c.5.1.7,0,.9-.3a13.081,13.081,0,0,0,.5-1.5,17.823,17.823,0,0,0,.4-2.6c0-.1,0-.1.1-.1a.749.749,0,0,1,.5.1c.1,0,.1.1.1.2a15.054,15.054,0,0,1-.5,2.8,7.964,7.964,0,0,1-.6,1.7,1.074,1.074,0,0,1-1.4.5L42,32.2a9.218,9.218,0,0,0-1.8-.3,6.89,6.89,0,0,1,.3-.8.187.187,0,0,1,.3,0,7.688,7.688,0,0,0,1.2.4Zm-2.5-6v-.1a7.459,7.459,0,0,1,1.5-.9c.1,0,.1,0,.1.1l.2.3v.1a4.617,4.617,0,0,0-1.5.9Zm.5,1v-.1a7.459,7.459,0,0,1,1.5-.9h.1l.2.4c0,.1,0,.1-.1.1a5.071,5.071,0,0,0-1.6.9Z" fill="#fff"/></svg>
      </div>

      <v-overlay :value="loading" z-index=9999>
        <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
      </v-overlay>

    </v-content>
</template>

<script>
import { loadGmapApi } from "vue2-google-maps";
export default {
  name: "GoogleMap",
  components: {
  },
  data: () => ({
    center: null,
    zoom: 14,
    mapTypeControl: false,
    marker_items: [],
    mapStyle: {
        disableDefaultUI: true,
    },
    result: null,
    dialog: true,
    refecture_id: '',
    routing: [],
    loading: false,
  }),
  async created() {
    this.init = this.storageGet('*')

    var shoplist_req = { params:{
      'shop_id': this.init.shop_id,
      'location': 0,
    }}
    var res = await this.apiCall('/user/follow_map_shops', shoplist_req)

    this.$set(this, 'result', res.shop_list[0])
    if (!res) return false;
    this.center = this.result.location;
  },
  async beforeMount() {
    var business_service_res = await this.apiCall('/business-service/get-info', { params:{} })
    if (!business_service_res.data) return false;
    loadGmapApi({
      key: business_service_res.data.google_api_key,
      libraries: "places"
    });
  },
  mounted(){

  },

  methods: {
    changeCenter() {
      this.center = this.changeShopList[0].location
    },
    changeLocation(location) {
      this.center = location
    },
    handleAfterChange(event, slick, currentSlide) {
      this.center = this.changeShopList[currentSlide].location
    },
    MakerClick(location){
      this.center = location
    },
    toMap() {
      var req = {
        destination: "https://www.google.com/maps/dir/?api=1&destination=" + this.center.lat + "," + this.center.lng,
        transition_type: 4,
      }
      if (!(this.screenTransition(req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    }
  }
}
</script>

<style scoped>
a {
    color: #333333;
}

#map {
    width: 100vw;
    height: 100vh;
}

#navi {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
}

.btns {
    width: 100vw;
    position: fixed;
    bottom: 15px;
    z-index: 200;
}

.followbtn {
    position: absolute;
    top:0;
    right: 0;
}

.star {
    margin-top: -60px;
}

</style>
